import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { useHStack } from '../HStack';
export function useVStack(props) {
  var _useContextSystem = useContextSystem(props, 'VStack'),
      _useContextSystem$exp = _useContextSystem.expanded,
      expanded = _useContextSystem$exp === void 0 ? false : _useContextSystem$exp,
      otherProps = _objectWithoutProperties(_useContextSystem, ["expanded"]);

  var hStackProps = useHStack(_objectSpread({
    direction: 'column',
    expanded: expanded
  }, otherProps));
  return hStackProps;
}